import {
  OPEN_HAMBURGER_MENU,
  OPEN_SEARCHBAR,
  MEMBER_UPDATED,
  IS_OPEN_LOGIN_FORM,
  STORY_HEADER_IN_VIEW,
  TOAST_MESSAGE,
  UPDATE_PODCAST_PLAYER,
} from "./actions";

function hamburgerMenuReducer(state = false, action) {
  switch (action.type) {
    case OPEN_HAMBURGER_MENU:
      return action.isHamburgerMenuOpen;
    default:
      return state;
  }
}

function searchBarReducer(state = false, action) {
  switch (action.type) {
    case OPEN_SEARCHBAR:
      return action.isSearchBarOpen;
    default:
      return state;
  }
}

function memberReducer(state = null, action) {
  switch (action.type) {
    case MEMBER_UPDATED:
      return action.member;

    default:
      return state;
  }
}

function loginReducer(state = false, action) {
  switch (action.type) {
    case IS_OPEN_LOGIN_FORM:
      return action.payload;
    default:
      return state;
  }
}

const userIntialState = {
  jwt_token: null,
};

function userReducer(state = userIntialState, action) {
  switch (action.type) {
    case "METYPE_JWT_TOKEN":
      return {
        ...state,
        jwt_token: action.payload,
      };

    default:
      return state;
  }
}

function storyHeaderReducer(state = true, action) {
  switch (action.type) {
    case STORY_HEADER_IN_VIEW:
      return action.payload;
    default:
      return state;
  }
}

function toastMessageReducer(state = "", action) {
  switch (action.type) {
    case TOAST_MESSAGE:
      return action.message;
    default:
      return state;
  }
}

const podcastPlayerInitialState = {
  podcastData: null,
  isPlaying: false,
  isClosebutton: false,
  isPlayingButton: false,
  currentTime: 0,
  duration: 0,
  publishDate: "",
  isLoading: false,
  error: "",
};

function podcastPlayerReducer(state = podcastPlayerInitialState, action) {
  switch (action.type) {
    case UPDATE_PODCAST_PLAYER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export const REDUCERS = {
  isHamburgerMenuOpen: hamburgerMenuReducer,
  isSearchBarOpen: searchBarReducer,
  member: memberReducer,
  isLoginOpen: loginReducer,
  userReducer: userReducer,
  storyHeaderInView: storyHeaderReducer,
  toastMessage: toastMessageReducer,
  podcastPlayer: podcastPlayerReducer,
};
